import { render, staticRenderFns } from "./djgz.vue?vue&type=template&id=9d6ecf00&scoped=true"
import script from "./djgz.vue?vue&type=script&lang=js"
export * from "./djgz.vue?vue&type=script&lang=js"
import style0 from "./djgz.vue?vue&type=style&index=0&id=9d6ecf00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d6ecf00",
  null
  
)

export default component.exports